import * as React from 'react';
import {Text, TextProps} from 'react-native';
import Styles from '../Styles';
type AVTextProps = TextProps & {
  children: React.ReactNode;
  accessibilityLabel?: string;
  accessibilityRole?: string;
  maxFontSizeMultiplier?: number;
  accessible?: boolean;
  testID?: string;
};

const AVText = (props: AVTextProps) => (
  <Text
    {...props}
    accessibilityLabel={props.accessibilityLabel}
    nativeID={
      props.testID ??
      props.nativeID ??
      props.accessibilityLabel?.replace(/\s+/g, '_')
    }
    testID={props.testID}
    accessible={props?.accessible}
    accessibilityRole={props?.accessibilityRole}
    maxFontSizeMultiplier={
      props?.maxFontSizeMultiplier ?? Styles.FontSizeMultiplier.maxfm7
    }
    style={[props.style]}
  />
);

export default AVText;
